export default "__VITE_ASSET__BliMRHZz__"